import { UserBasic, UserRoleEnum } from 'Entities/account'

export const isAdminAccount = (account?: UserBasic | null) => {
  return !!account?.authorities?.includes(UserRoleEnum.ROLE_ADMIN)
}

export const isSchoolAccount = (account?: UserBasic | null) => {
  if (!account) return false

  return !!account.schoolId || !!account.authorities?.includes(UserRoleEnum.ROLE_SCHOOL_OWNER)
}
